import { IconButton } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div``;

export const ContainerPreview = styled.div<{ previewImage: string }>`
	display: flex;
	flex-direction: ${(props) => props.previewImage};
	justify-content: flex-start;
	align-items: center;
	flex-wrap: wrap;
	gap: 1rem;
	margin: 1rem 0 0;
`;
export const ButtonBaseDeletePreview = styled(IconButton)`
	&&& {
		color: ${({ theme }) => theme.red};
		fill: ${({ theme }) => theme.red};

		.MuiSvgIcon-root {
			color: ${({ theme }) => theme.red};
			fill: ${({ theme }) => theme.red};
		}
	}
`;
export const ButtonDeletePreview = styled(ButtonBaseDeletePreview)`
	&&& {
		position: absolute;
		top: 0;
		right: 0;
		display: none;
	}
`;
export const ButtonDeleteFile = styled(ButtonBaseDeletePreview)`
	&&& {
		margin: 0 0 0 auto;
	}
`;

export const ItemPreview = styled.div`
	cursor: zoom-in;
	position: relative;
	width: 100%;
	max-width: 100px;
	overflow: hidden;

	&:hover {
		${ButtonDeletePreview} {
			display: block;
		}
	}
`;
export const ItemFile = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 0.6rem;
	background-color: ${({ theme }) => theme.white};
	box-shadow: 2px 2px 2px 0 rgba(0, 0, 0, 0.2);
	border-radius: 5px;
	padding: 1rem;
	width: 100%;
	max-width: 600px;

	> p {
		display: flex;
		flex-wrap: nowrap;
		flex-direction: row;
		margin: 0;
		max-width: 265px;

		> span {
			max-width: 280px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: pre;
		}
	}

	@media (max-width: 560px) {
		> p {
			max-width: 70%;
		}
	}
	@media (max-width: 406px) {
		> p {
			max-width: 53%;
		}
	}
`;

export const ImagePreview = styled.img`
	width: 100%;
	max-width: 100px;
	height: 100px;
`;

export const AreaIcons = styled.div`
	margin-left: auto;
`;
